import styled, { css } from 'styled-components';

const Box = styled.div`
    background: rgba(0, 0, 0, 0.66);
    -webkit-box-shadow: -5px 10px 135px -17px #000;
    box-shadow: -5px 10px 135px -17px #000;
    flex: 1 1 auto;
    margin-bottom:20px;
    padding: 20px;
    color: #fff;
    position:relative;
    display:flex;
    flex-direction: column;
    overflow-y: scroll;
    overflow-x: hidden;

    &:last-child {
        flex: 1 1 auto;
        margin-bottom: 0px;
    }
    &.noBottomMargin {
        margin-bottom: 0px;
    }
    &.marginLeft {
        margin-left: 10px;
    }
    &.marginRight {
        margin-right: 10px;
    }

    @media print {
      border: 1px solid #777;
      display: block !important;
    }

    ${props => props.contentHeight && css`
      flex-grow: initial;
    `}

    ${props => props.pt1 && css`
      padding-top: 10px;
    `}

    ${props => props.noFlex && css`
      flex: none !important;
    `}

    ${props => props.marginLeft && css`
      margin-left: 10px;
    `}

    ${props => props.marginRight && css`
      margin-right: 10px;
    `}

    ${props => props.mr0 && css`
      margin-right: 0px !important;
    `}

    ${props => props.mb2 && css`
      margin-bottom: 20px !important;
    `}

    ${props => props.marginRight && css`
      margin-right: 10px;
    `}

`;

const BoxHeadline = styled.h1`

`;

const BoxContent = styled.div`
  ${props => props.disabled && css`
    filter: blur(5px);
    overflow:hidden;
    opacity:0.7;
  `}

  ${props => props.paddingTop && css`
    padding-top: 20px;
  `}
`;

const MainHeadingContainer = styled.div`
  background-color: #0C0E16;
  margin: -27px -27px 15px -27px;
  padding: 12px 20px;
  margin: 0
  padding: 0

  ${props => props.lessBottomMargin && css`
    margin-bottom:5px;
  `}
`;

const MainHeading = styled.h1`
  text-transform: uppercase;
  margin-bottom: 0px;
  margin-top:0;
  font-size: 13px;
  letter-spacing: 1px;

  ${props => props.big && css`
    font-size:20px;
    margin-bottom:10px;
    letter-spacing: 2px;
  `}

  ${props => props.mb0 && css`
    margin-bottom: 0px;
  `}
`;

const MainHeadingBig = styled.h1`
  text-transform: uppercase;
  margin-bottom: 10px;
  font-size: 26px;
  margin-top:0;
`;

export const SubHeading = styled.span`
  display: block;
  font-size: 10px;
`;

const Description = styled.p`
  font-size: 12px;
  margin-top: 10px;
`

const NoData = styled.div`
  position:absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  display:flex;
  &:after {
    content: "No data available";
    margin: 0 auto;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    text-align: center;
    opacity:0.9
  }
`;

const BoxButton = styled.button`
  border-radius: 3px !important;
  padding: 0.5em 0;
  background: transparent;
  background-color: transparent !important;
  color: #fff;
  border: 1px solid #fff;
  float: right;
  font-size:10px;
  text-transform: uppercase;
  min-width: 85px;
  padding: 5px;

  &.margin-right {
    margin-right:5px;
  }

  ${props => props.dark && css`
    background: #222;
    background-color: #222 !important;
    float: none;
    margin-top: 5px;
  `}

  ${props => props.primary && css`
    background-color: #e6ba5b !important;
    border-color: #e6ba5b;
  `}

`;

const CTAButton = styled.button`
  border-radius: 3px !important;
  padding: 0.5em 0;
  background: transparent;
  background-color: #e6ba5b;
  color: #fff;
  border: 0;
  float: right;
  font-size:13px;
  text-transform: uppercase;
  min-width: 100px;
  width: 80%;
  margin: 0 auto;
  padding: 15px;
  -webkit-box-shadow: -5px 10px 135px -17px #000;
  box-shadow: -5px 10px 135px -17px #000;
  z-index: 99;

  &.margin-right {
    margin-right:5px;
  }

  ${props => props.invisible && css`
    background: transparent;
    background-color: transparent;
    -webkit-box-shadow: none;
    box-shadow: none;
    cursor: none;
    pointer-events: none;
  `}
`;

const ReportHeading = styled.h1`
  margin-bottom: 15px;
  margin-top:0;
  font-size: 25px;
`;


const Divider = styled.hr`
  height:1px;
  color:#555;
  width:100%;
  opacity:0.2;

  ${props => props.noTopMargin && css`
    margin-top: 0px;
  `}

  ${props => props.my0 && css`
    margin: 0px;
  `}
`;

export {Box, BoxContent, BoxHeadline, BoxButton, CTAButton, MainHeadingContainer, MainHeading, MainHeadingBig, NoData, ReportHeading, Description, Divider}



// WEBPACK FOOTER //
// ./src/components/StyledComponents.js